import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";


export class ExpensesCategoriesMultiSelectListCtrl implements IController {

  selectedIds: string[];
  disabledIds: string[];
  isActive: boolean;
  ngPlaceholder: any;
  onChange: Function;

  private expensesCategoriesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: string;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $expensesCategories, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.expensesCategoriesRef = this.$expensesCategories();
    this.loadLimit = 20;

    if (!this.selectedIds) {
      this.selectedIds = []
    }
    this.expensesCategoriesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.expensesCategoriesRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(expenseCategoryId, isSelected) {
    this.onChange({
      expenseCategoryIds: isSelected ? _.concat(this.selectedIds || [], [expenseCategoryId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== expenseCategoryId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({expenseCategoryIds: []});
    } else {
      this.onChange({expenseCategoryIds: this.infiniteScroll?.getItems()?.map((expenseCategory) => expenseCategory.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(expenseCategory => expenseCategory.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.expensesCategoriesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      active: this.isActive,
      sort: 'name,asc'
    };
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCategoriesMultiSelectList', {
    bindings: {
      selectedIds: '<',
      disabledIds: '<?',
      isActive: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./expenses-categories-multi-select-list.html').default,
    controller: ExpensesCategoriesMultiSelectListCtrl
  });
